<template>

  <div>
    <div
      class="buymodal-block__body">

      <div
        class="body-info">
        <div
          class="body-info__title">
          Проверьте правильность введенных данных
        </div>
        <div
          class="body-info__block double">
          <div
            class="info-title">
            Данные об устройстве
            <span
              class="text">
              Для изменения обратитесь в чат тех. поддержки
            </span>
          </div>
          <div
            class="info-table">
            <div
              v-if="model.imei"
              class="info-table__line">
              <div
                class="label">
                IMEI
              </div>
              <div
                class="value">
                {{ model.imei }}
              </div>
            </div>
            <div
              class="info-table__line"
              v-for="(item, i) in model.mobile" :key="i"
              v-if="arrayName.find(item => item.key === i)">
              <div
                class="label">
                {{ arrayName.find(item => item.key === i).name }}
              </div>
              <div
                class="value">
                {{ item }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="body-info__block double">
          <div
            class="info-title">
            Данные о клиенте
            <button
              type="button"
              class="btn next"
              @click.prevent="changeInfo()">
              Изменить
            </button>
          </div>
          <div
            class="info-table">
            <div
              class="info-table__line">
              <div
                class="label">
                ФИО
              </div>
              <div
                class="value">
                {{ clientInfo.lastname }} {{ clientInfo.firstname }} {{ clientInfo.patronymic }}
              </div>
            </div>
            <div
              class="info-table__line">
              <div
                class="label">
                Телефон
              </div>
              <div
                class="value">
                {{ clientInfo.telefon }}
              </div>
            </div>
            <div
              class="info-table__line">
              <div
                class="label">
                E-mail
              </div>
              <div
                class="value">
                {{ clientInfo.email }}
              </div>
            </div>
            <div
              class="info-table__line">
              <div
                class="label">
                Номер удостоверения и ИИН
              </div>
              <div
                class="value">
                {{ clientInfo.passportserial }}
              </div>
            </div>
            <div
              class="info-table__line">
              <div
                class="label">
                Дата выдачи удостоверения
              </div>
              <div
                class="value">
                {{ clientInfo.passportdate }}
              </div>
            </div>
            <div
              class="info-table__line">
              <div
                class="label">
                Кем выдано
              </div>
              <div
                class="value">
                {{ clientInfo.passportwho }}
              </div>
            </div>
            <div
              class="info-table__line">
              <div
                class="label">
                Дата рождения
              </div>
              <div
                class="value">
                {{ clientInfo.date }}
              </div>
            </div>
            <div
              class="info-table__line">
              <div
                class="label">
                Адрес регистрации
              </div>
              <div
                class="value">
                {{ clientInfo.address }}
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div
      class="buymodal-block__footer">
      <button
        type="button"
        class="btn cancel"
        @click.prevent="$emit('leave')">
        Отказаться
      </button>
      <button
        type="button"
        class="btn next"
        @click.prevent="next()">
        Завершить выкуп
      </button>
    </div>

  </div>

</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  props: ['user'],
  data() {
    return {
      arrayName: [
        { key: 'IMEI', name: 'IMEI' },
        { key: 'SerialNumber', name: 'Серийный номер' },
        { key: 'ModelName', name: 'Модель' },
        { key: 'Capacity', name: 'Объем' },
        { key: 'Color', name: 'Цвет' },
        { key: 'manufactorer', name: 'Производитель' },
        { key: 'model', name: 'Модель' },
      ],
    }
  },
  computed: {
    ...mapState('buyphones', ['model', 'clientInfo']),
  },
  methods: {
    ...mapActions('buyphones', ['updateOrder']),
    ...mapMutations('buyphones', ['CHANGE_SCREEN_THREE']),

    changeInfo() {
      this.CHANGE_SCREEN_THREE({ show2: true, show3: false });
    },

    next() {
      this.$emit('changeScreen');
    },
  }
}
</script>

<style lang="css">
</style>
